export enum InspectionMenuTabs {
  SiteInfo = 'Site Info',
  Areas = 'Areas',
  AllScopes = 'All Scopes',
  Safety = 'Safety',
}

export type InspectionActiveOption = InspectionMenuTabs.SiteInfo | InspectionMenuTabs.Areas | InspectionMenuTabs.AllScopes | InspectionMenuTabs.Safety;
